import { store } from "../utils/store.js";
/* ─── DESIGN TOKENS ─────────────────────────────────────────────────── */
const C = {
  // Light theme — content area
  bg:      "#f4f6f9",
  s1:      "#ffffff",
  s2:      "#f8f9fc",
  s3:      "#edf0f5",
  s4:      "#e4e7ed",
  border:  "#dde1ea",
  accent:  "#7c3aed", accentL: "#a78bfa", accentD: "#5b21b6",
  sage:    "#6b9e67", danger: "#d94040", success: "#1aab6d",
  text:    "#1c2437",
  t2:      "#526070",
  t3:      "#8897a4",
  t4:      "#c4cdd6",
};

// Sidebar dark tokens (HubSpot-style dark left nav)
const SB = {
  bg:     "#333333",
  s2:     "#424242",
  border: "#4a4a4a",
  text:   "#ffffff",
  t2:     "#b0b0b0",
  t3:     "#787878",
  active: "#484848",
};

const S = {
  card: { background: C.s1, border: `1px solid ${C.border}`, borderRadius: 10, boxShadow: "0 1px 3px rgba(28,36,55,0.06)" },
  input: { background: C.s1, border: `1px solid ${C.border}`, borderRadius: 7, padding: "9px 13px", color: C.text, fontSize: 14, width: "100%", outline: "none", boxSizing: "border-box", fontFamily: "inherit", transition: "border-color 0.2s" },
  btn: { background: C.accent, color: "#fff", border: "none", borderRadius: 5, padding: "10px 22px", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", transition: "all 0.12s", whiteSpace: "nowrap" },
  btnGhost: { background: "#fff", color: C.t2, border: `1px solid ${C.border}`, borderRadius: 5, padding: "9px 18px", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", transition: "all 0.12s", whiteSpace: "nowrap" },
  label: { fontSize: 12, fontWeight: 500, color: C.t2, letterSpacing: "0.04em", marginBottom: 6, display: "block" },
  h1: { fontFamily: "'Plus Jakarta Sans', -apple-system, sans-serif", fontSize: 24, fontWeight: 700, color: C.text, margin: 0 },
  h2: { fontFamily: "'Plus Jakarta Sans', -apple-system, sans-serif", fontSize: 20, fontWeight: 600, color: C.text, margin: "0 0 4px 0" },
  sub: { fontSize: 14, color: C.t2, marginBottom: 24, marginTop: 4 },
};

const NAV = [
  { id: "dashboard",    label: "Dashboard",       icon: "▦" },
  { id: "inbox",        label: "Inbox",            icon: "📥" },
  { id: "brain",        label: "Business Brain",   icon: "◈", badge: "NEW" },
  { id: "campaigns",    label: "Campaigns",        icon: "⚡" },
  { id: "research",     label: "Research & Strategy", icon: "⊹" },
  { type: "section",    label: "Inquiries & Contacts" },
  { id: "lead-agent",   label: "Lead Agent",        icon: "🎯", badge: "NEW" },
  { id: "conversion",   label: "Conversion",        icon: "💰", badge: "NEW" },
  { id: "crm",          label: "Contacts",         icon: "◈" },
  { id: "inquiries",    label: "Inquiries",        icon: "◷" },
  { id: "reservations", label: "Bookings",         icon: "◉" },
  { type: "section",    label: "Marketing" },
  { id: "website",      label: "Website",          icon: "⬡" },
  { id: "content",      label: "Content Studio",   icon: "✦" },
  { id: "content-engine", label: "Content Agent",   icon: "⚡", badge: "NEW" },
  { id: "image-studio",  label: "Creative Agent",   icon: "🎨", badge: "NEW" },
  { id: "seo",          label: "SEO",              icon: "⊹", badge: "NEW" },
  { id: "aeo",          label: "AI Visibility",    icon: "◎", badge: "NEW" },
  { id: "authority",    label: "Authority Agent",   icon: "🛡", badge: "NEW" },
  { id: "integrations", label: "Integrations",      icon: "⊕" },
  { id: "ads",           label: "Ads",              icon: "◬" },
  { id: "call-tracking", label: "Call Tracking",     icon: "📞", badge: "NEW" },
  { id: "social",        label: "Social Planner",    icon: "◎" },
  { id: "gbp",          label: "Google Business",  icon: "G", badge: "NEW" },
  { id: "marketing",    label: "Messaging",        icon: "✉" },
  { id: "reviews",      label: "Reviews",          icon: "★" },
  { id: "bloggers",     label: "Influencers",      icon: "◉" },
  { type: "divider" },
  { id: "autopilot",    label: "Autopilot",        icon: "⚡", badge: "NEW" },
  { id: "scheduler",    label: "Scheduler",        icon: "◷", badge: "NEW" },
  { id: "media",        label: "Media Library",    icon: "⊞" },
  { id: "reports",      label: "Reports",          icon: "◑" },
  { id: "pricing",      label: "Plans & Pricing",  icon: "◈" },
  { type: "section",    label: "Configuration" },
  { id: "roles",        label: "Roles & Permissions", icon: "◑" },
  { id: "brand",        label: "Brand Guidelines", icon: "◆" },
  { id: "settings",          label: "Settings",          icon: "⚙" },
  { id: "admin",             label: "Plan Dashboard",    icon: "⚿", superAdminOnly: true },
  { id: "admin-workspaces",  label: "Workspaces", icon: "🏢", superAdminOnly: true },
  { id: "super-users",       label: "Users",      icon: "👥", superAdminOnly: true },
  { id: "super-activity",      label: "Activity",     icon: "📜", superAdminOnly: true },
  { id: "super-system-health", label: "System Health", icon: "💓", superAdminOnly: true },
  { id: "super-reports",       label: "Reports",       icon: "📊", superAdminOnly: true },
  { id: "super-cost-usage",    label: "Cost & Usage", icon: "💰", superAdminOnly: true },
  { id: "super-at-risk",       label: "At-Risk",      icon: "🚩", superAdminOnly: true },
  { id: "super-white-label",   label: "White Label",  icon: "🌐", superAdminOnly: true },
  { id: "authority-library",   label: "Citation Library", icon: "📚", superAdminOnly: true },
  { id: "agency-workspaces",   label: "Workspaces",   icon: "🏢", agencyAdminOnly: true },
  { id: "agency-users",      label: "Users",      icon: "👥", agencyAdminOnly: true },
];

const GM = "#8b5cf6";
const RV = "#f59e0b";
const CM_COL = "#6366f1";
const RS_COL = "#6366f1";

export const SEED_REVIEWS = [
  { id:1, reviewer:"Sarah M.",  rating:5, date:"Apr 20, 2026", text:"Absolutely stunning experience. The truffle pasta was out of this world and our server Marcus was exceptional. Will be back for our anniversary!", responded:false, response:null, platform:"google", sentiment:"positive" },
  { id:2, reviewer:"James K.",  rating:2, date:"Apr 18, 2026", text:"Disappointed with the service tonight. Waited 45 minutes for our main course with no explanation. The food was good when it arrived but the wait ruined the evening.", responded:false, response:null, platform:"google", sentiment:"negative" },
  { id:3, reviewer:"Priya S.",  rating:5, date:"Apr 15, 2026", text:"Came for my birthday and was blown away. The chef came out to greet us personally and we got a complimentary dessert with candles. The lamb was absolute perfection.", responded:true, response:"Thank you so much Priya! Your birthday celebration meant everything to us. We hope to see you again very soon.", platform:"google", sentiment:"positive" },
  { id:4, reviewer:"Tom W.",    rating:3, date:"Apr 12, 2026", text:"Food was delicious but the noise level on Friday nights makes conversation impossible. Great for a casual outing, not ideal for a quiet date night.", responded:false, response:null, platform:"google", sentiment:"neutral" },
  { id:5, reviewer:"Emily C.",  rating:5, date:"Apr 10, 2026", text:"Best restaurant in the city, hands down. Every dish was a masterpiece. The sommelier's wine pairing was spot on. Already booked again for next month.", responded:true, response:"Emily, thank you for these kind words! We're so thrilled the wine pairings hit the mark — see you next month!", platform:"google", sentiment:"positive" },
  { id:6, reviewer:"David R.",  rating:1, date:"Apr 8,  2026", text:"Found a hair in my pasta. When we told the server they were dismissive and didn't offer any compensation. Very disappointing at this price point.", responded:false, response:null, platform:"google", sentiment:"negative" },
  { id:7, reviewer:"Anika P.",  rating:4, date:"Apr 5,  2026", text:"Really enjoyable dinner. The tasting menu was creative and beautifully presented. Slight wait between courses but the quality made up for it.", responded:false, response:null, platform:"google", sentiment:"positive" },
  { id:8, reviewer:"Marcus L.", rating:5, date:"Apr 2,  2026", text:"Took my wife here for our 10th anniversary. They had flowers and a card waiting at the table. That level of personal touch is what makes this place truly special.", responded:false, response:null, platform:"google", sentiment:"positive" },
];


/* ─── Website Builder inline editor script (shared: WebsiteBuilder + EmailInlineEditor) ── */
export const WB_EDITOR_SCRIPT = `<script id="__kurb-editor">(function(){
  // Cleanup prior instances
  ['__kurb-dot','__kurb-tb'].forEach(function(id){var o=document.getElementById(id);if(o&&o.parentNode)o.parentNode.removeChild(o);});
  var os=document.getElementById('__kurb-style');if(os&&os.parentNode)os.parentNode.removeChild(os);

  // Purple dot in corner — confirms script ran (visible in iframe bottom-right)
  var dot=document.createElement('div');
  dot.id='__kurb-dot';
  dot.style.cssText='position:fixed;bottom:6px;right:6px;z-index:2147483647;width:8px;height:8px;border-radius:50%;background:#7c3aed;pointer-events:none;';
  document.body.appendChild(dot);

  // CSS-based hover — no mouse events needed, browser handles it natively
  var style=document.createElement('style');
  style.id='__kurb-style';
  style.textContent='[data-ke]{cursor:text!important;}[data-ke]:not([contenteditable]):hover{outline:2px solid rgba(124,58,237,0.75)!important;outline-offset:2px!important;position:relative;}[data-ke][contenteditable]{outline:2px solid #7c3aed!important;outline-offset:2px!important;}img:not([data-ke]){position:relative;}img:not([data-ke]):hover{outline:2px solid rgba(124,58,237,0.75)!important;outline-offset:2px!important;cursor:pointer!important;}img.kurb-img-selected{outline:3px solid #7c3aed!important;outline-offset:2px!important;}.kurb-img-wrap{position:relative;display:inline-block;}.kurb-img-wrap::after{content:"✦ Replace / Generate";position:absolute;top:8px;left:8px;background:rgba(124,58,237,0.85);color:#fff;font-size:11px;font-weight:600;padding:4px 10px;border-radius:5px;pointer-events:none;opacity:0;transition:opacity 0.15s;font-family:system-ui,sans-serif;}.kurb-img-wrap:hover::after{opacity:1;}';
  (document.head||document.body).appendChild(style);

  // Mark all text-bearing elements with data-ke
  var SKIP=/^(HTML|HEAD|BODY|SCRIPT|STYLE|NOSCRIPT|IFRAME|SVG|PATH|G|DEFS|USE|META|LINK|TITLE|BR|HR|IMG|INPUT|SELECT|TEXTAREA|FORM|CANVAS|VIDEO|AUDIO)$/;
  function mark(){
    // Named text tags
    var tags='h1,h2,h3,h4,h5,h6,p,button,a,li,span,label,strong,em,b,i,small,td,th,dt,dd,figcaption,caption,blockquote';
    document.querySelectorAll(tags).forEach(function(el){el.setAttribute('data-ke','1');});
    // Any element with direct text node children
    var all=document.body?document.body.querySelectorAll('*'):[];
    for(var i=0;i<all.length;i++){
      var el=all[i];
      if(el.hasAttribute('data-ke')||SKIP.test(el.tagName))continue;
      for(var j=0;j<el.childNodes.length;j++){
        if(el.childNodes[j].nodeType===3&&el.childNodes[j].textContent.trim()){el.setAttribute('data-ke','2');break;}
      }
    }
  }
  mark();

  // Toolbar
  var tb=document.createElement('div');
  tb.id='__kurb-tb';
  tb.style.cssText='position:fixed;z-index:2147483647;display:none;align-items:center;gap:4px;background:#fff;border:1px solid #dde1ea;border-radius:10px;padding:5px 8px;box-shadow:0 4px 24px rgba(0,0,0,0.18);font-family:sans-serif;flex-wrap:nowrap;';

  var _SVG={
    bold:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"/><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"/></svg>',
    italic:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="4" x2="10" y2="4"/><line x1="14" y1="20" x2="5" y2="20"/><line x1="15" y1="4" x2="9" y2="20"/></svg>',
    underline:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 4v6a6 6 0 0 0 12 0V4"/><line x1="4" y1="20" x2="20" y2="20"/></svg>',
    strike:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="12" x2="20" y2="12"/><path d="M17.5 6.5C17 5 15.5 4 14 4c-2 0-4 1.5-4 4 0 2 1.5 3 4 3h2"/><path d="M6.5 17C7 19 8.5 20 10 20c2 0 4-1.5 4-4 0-1.5-1-2.5-2.5-3"/></svg>',
    alignL:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="18" y2="18"/></svg>',
    alignC:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/></svg>',
    alignR:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="9" y1="12" x2="21" y2="12"/><line x1="6" y1="18" x2="21" y2="18"/></svg>'
  };
  function mkFmtBtn(icon,title,cmd){
    var b=document.createElement('button');b.title=title;b.innerHTML=icon;
    b.style.cssText='background:none;color:#1c2437;border:1px solid #e4e7ed;border-radius:4px;padding:4px 6px;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;';
    b.addEventListener('mousedown',function(e){e.preventDefault();document.execCommand(cmd,false,null);});
    b.addEventListener('mouseover',function(){b.style.background='#f4f6f9';});
    b.addEventListener('mouseout',function(){b.style.background='none';});
    return b;
  }
  function mkSep(){var s=document.createElement('div');s.style.cssText='width:1px;height:18px;background:#e4e7ed;margin:0 2px;flex-shrink:0;';return s;}

  // Format group (normal mode)
  var fmtGrp=document.createElement('span');fmtGrp.style.cssText='display:flex;align-items:center;gap:3px;';
  fmtGrp.appendChild(mkFmtBtn(_SVG.bold,'Bold','bold'));
  fmtGrp.appendChild(mkFmtBtn(_SVG.italic,'Italic','italic'));
  fmtGrp.appendChild(mkFmtBtn(_SVG.underline,'Underline','underline'));
  fmtGrp.appendChild(mkFmtBtn(_SVG.strike,'Strikethrough','strikeThrough'));
  fmtGrp.appendChild(mkSep());
  fmtGrp.appendChild(mkFmtBtn(_SVG.alignL,'Align left','justifyLeft'));
  fmtGrp.appendChild(mkFmtBtn(_SVG.alignC,'Align center','justifyCenter'));
  fmtGrp.appendChild(mkFmtBtn(_SVG.alignR,'Align right','justifyRight'));
  fmtGrp.appendChild(mkSep());
  tb.appendChild(fmtGrp);

  // AI button (normal mode)
  var aiBtn=document.createElement('button');aiBtn.textContent='✦ AI';
  aiBtn.title='Rewrite with AI';
  aiBtn.style.cssText='background:linear-gradient(135deg,#7c3aed,#a855f7);color:#fff;border:none;border-radius:5px;padding:4px 10px;font-size:12px;font-weight:700;cursor:pointer;font-family:sans-serif;';
  tb.appendChild(aiBtn);
  tb.appendChild(mkSep());

  // Save / Cancel (normal mode)
  var sv=document.createElement('button');sv.textContent='Save';
  sv.style.cssText='background:#7c3aed;color:#fff;border:none;border-radius:5px;padding:4px 14px;font-size:12px;font-weight:700;cursor:pointer;font-family:sans-serif;';
  var cn=document.createElement('button');cn.textContent='Cancel';
  cn.style.cssText='background:none;color:#888;border:1px solid #dde1ea;border-radius:5px;padding:4px 10px;font-size:12px;cursor:pointer;font-family:sans-serif;';
  tb.appendChild(sv);tb.appendChild(cn);

  // AI rewrite group (AI mode, hidden by default)
  var aiGrp=document.createElement('span');aiGrp.style.cssText='display:none;align-items:center;gap:6px;';
  var aiBk=document.createElement('button');aiBk.textContent='←';aiBk.title='Back';
  aiBk.style.cssText='background:none;color:#888;border:1px solid #e4e7ed;border-radius:4px;padding:3px 7px;font-size:12px;cursor:pointer;font-family:sans-serif;';
  var aiInp=document.createElement('input');
  aiInp.placeholder='e.g. make it shorter, more exciting…';
  aiInp.style.cssText='border:1px solid #dde1ea;border-radius:6px;padding:4px 10px;font-size:12px;font-family:sans-serif;outline:none;width:220px;color:#1c2437;';
  var aiGo=document.createElement('button');aiGo.textContent='Rewrite ✦';
  aiGo.style.cssText='background:linear-gradient(135deg,#7c3aed,#a855f7);color:#fff;border:none;border-radius:5px;padding:4px 12px;font-size:12px;font-weight:700;cursor:pointer;font-family:sans-serif;white-space:nowrap;';
  aiGrp.appendChild(aiBk);aiGrp.appendChild(aiInp);aiGrp.appendChild(aiGo);
  tb.appendChild(aiGrp);

  document.body.appendChild(tb);

  // Toggle AI / normal mode
  function enterAI(){
    fmtGrp.style.display='none';aiBtn.style.display='none';
    sv.style.display='none';cn.style.display='none';
    aiGrp.style.display='flex';
    aiInp.value='';setTimeout(function(){aiInp.focus();},0);
    repositionTb();
  }
  function exitAI(){
    aiGrp.style.display='none';
    fmtGrp.style.display='flex';aiBtn.style.display='';
    sv.style.display='';cn.style.display='';
    repositionTb();
  }
  aiBtn.addEventListener('mousedown',function(e){e.preventDefault();enterAI();});
  aiBk.addEventListener('mousedown',function(e){e.preventDefault();exitAI();});

  // Send rewrite request to parent
  function doRewrite(){
    var inst=aiInp.value.trim();if(!inst||!active)return;
    var txt=active.innerText||active.textContent||'';
    aiGo.textContent='Rewriting…';aiGo.disabled=true;aiInp.disabled=true;
    window.parent.postMessage({type:'wb-ai-rewrite',text:txt,instruction:inst,tag:active.tagName},'*');
  }
  aiGo.addEventListener('mousedown',function(e){e.preventDefault();doRewrite();});
  aiInp.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();doRewrite();}});

  // Receive result from parent
  window.addEventListener('message',function(e){
    if(!e.data||e.data.type!=='wb-ai-result')return;
    if(active){active.textContent=e.data.text||'';}
    aiGo.textContent='Rewrite ✦';aiGo.disabled=false;aiInp.disabled=false;
    exitAI();
  });

  var active=null,orig=null;
  function repositionTb(){
    if(!active)return;
    var r=active.getBoundingClientRect();
    var tbW=tb.offsetWidth||420;
    var t=r.bottom+8;if(t+50>window.innerHeight)t=r.top-54;
    var l=r.left;if(l+tbW>window.innerWidth)l=window.innerWidth-tbW-8;if(l<4)l=4;
    tb.style.top=t+'px';tb.style.left=l+'px';
  }
  function showTb(el){
    tb.style.display='flex';
    repositionTb();
  }
  function commit(){
    if(!active)return;
    active.removeAttribute('contenteditable');
    tb.style.display='none';active=null;orig=null;
    window.parent.postMessage({type:'wb-inline-edit',html:'<!DOCTYPE html>'+document.documentElement.outerHTML},'*');
  }
  function cancel(){
    if(!active)return;
    if(orig!==null)active.innerHTML=orig;
    active.removeAttribute('contenteditable');
    tb.style.display='none';active=null;orig=null;
  }
  sv.addEventListener('mousedown',function(e){e.preventDefault();commit();});
  cn.addEventListener('mousedown',function(e){e.preventDefault();cancel();});
  document.addEventListener('click',function(e){
    if(tb.contains(e.target))return;
    if(active&&(e.target===active||active.contains(e.target)))return;
    if(active){commit();return;}
    var el=e.target;
    // Image click — mark the element and ask parent to open picker
    if(el&&el.tagName==='IMG'){
      document.querySelectorAll('img[data-kurb-pending]').forEach(function(i){
        i.removeAttribute('data-kurb-pending');i.classList.remove('kurb-img-selected');
      });
      el.setAttribute('data-kurb-pending','1');
      el.classList.add('kurb-img-selected');
      window.parent.postMessage({type:'wb-img-click',src:el.getAttribute('src')},'*');
      return;
    }
    if(!el||!el.getAttribute||!el.getAttribute('data-ke'))return;
    active=el;orig=el.innerHTML;
    el.setAttribute('contenteditable','true');
    showTb(el);el.focus();
  });
  document.addEventListener('keydown',function(e){
    if(!active)return;
    if(e.key==='Escape'){e.preventDefault();cancel();}
    if(e.key==='s'&&(e.metaKey||e.ctrlKey)){e.preventDefault();commit();}
  });
  // Receive image replacement (or cancel) from parent picker
  window.addEventListener('message',function(e){
    if(!e.data||e.data.type!=='wb-img-replace')return;
    var el=document.querySelector('img[data-kurb-pending]');
    if(!el)return;
    el.removeAttribute('data-kurb-pending');el.classList.remove('kurb-img-selected');
    if(!e.data.url)return; // cancelled
    el.src=e.data.url;el.setAttribute('src',e.data.url);
    window.parent.postMessage({type:'wb-inline-edit',html:'<!DOCTYPE html>'+document.documentElement.outerHTML},'*');
  });
})();<\/script>`;

const SOCIAL_CHAR_LIMITS = {
  gbp: 1500, instagram: 2200, facebook: 63206, linkedin: 3000,
  tiktok: 2200, twitter: 280, youtube: 5000, pinterest: 500,
};

// Max images per platform (verified limits)
const SOCIAL_IMAGE_LIMITS = {
  gbp: 1,        // GBP posts: 1 photo only
  instagram: 10, // Carousel: up to 10
  facebook: 10,  // Up to 10 per post
  linkedin: 9,   // Up to 9 images
  tiktok: 35,    // Photo slideshow: up to 35
  twitter: 4,    // Up to 4 images
  youtube: 1,    // 1 thumbnail
  pinterest: 1,  // 1 image per pin
};

const SOCIAL_PLATFORMS = [
  { id:"gbp",       name:"Google Business", short:"GBP",       icon:"G",  color:"#4285f4", desc:"Publish posts to Google Business Profile" },
  { id:"facebook",  name:"Facebook",        short:"Facebook",  icon:"f",  color:"#1877f2", desc:"Post to your Facebook Page" },
  { id:"instagram", name:"Instagram",       short:"Instagram", icon:"⬡",  color:"#e1306c", desc:"Share to Instagram feed and stories" },
  { id:"linkedin",  name:"LinkedIn",        short:"LinkedIn",  icon:"in", color:"#0a66c2", desc:"Post to your LinkedIn company page" },
  { id:"tiktok",    name:"TikTok",          short:"TikTok",    icon:"♪",  color:"#010101", desc:"Share to TikTok business account" },
  { id:"youtube",   name:"YouTube",         short:"YouTube",   icon:"▶",  color:"#ff0000", desc:"Post to your YouTube channel" },
  { id:"twitter",   name:"X / Twitter",     short:"X",         icon:"✕",  color:"#000000", desc:"Post to your X (Twitter) account" },
  { id:"pinterest", name:"Pinterest",       short:"Pinterest", icon:"P",  color:"#e60023", desc:"Pin to your Pinterest boards" },
];

const INTEGRATION_PLATFORMS = [
  { id:"wordpress", name:"WordPress",  icon:"W", color:"#21759b", live:true,  desc:"Publish blog posts directly to your WordPress site via REST API." },
  { id:"webhook",   name:"Webhook",    icon:"⚡", color:"#f59e0b", live:true,  desc:"Send content to any platform via Zapier, Make, or a custom endpoint." },
  { id:"wix",       name:"Wix",        icon:"W", color:"#0c6efc", live:false, desc:"Publish to your Wix blog. Requires OAuth — coming soon." },
  { id:"shopify",   name:"Shopify",    icon:"S", color:"#96bf48", live:false, desc:"Post to your Shopify blog. Requires OAuth — coming soon." },
  { id:"webflow",   name:"Webflow",    icon:"W", color:"#4353ff", live:false, desc:"Publish to Webflow CMS collections — coming soon." },
  { id:"squarespace", name:"Squarespace", icon:"■", color:"#222", live:false, desc:"Publish to Squarespace blog — coming soon." },
];

export { C, SB, S, NAV, GM, RV, CM_COL, RS_COL, SOCIAL_CHAR_LIMITS, SOCIAL_IMAGE_LIMITS, SOCIAL_PLATFORMS, INTEGRATION_PLATFORMS };

export function buildBrandGuardrails(g) {
  if (!g) return "";
  const parts = [
    "BRAND GUARDRAILS — Follow strictly. Only use the verified facts listed below.",
    "DO NOT invent biographical details, childhood stories, specific dates, ages, apprenticeships, awards, or any claims not explicitly provided here.",
  ];
  if (g.voice)          parts.push(`Brand voice/tone: ${g.voice}`);
  if (g.facts)          parts.push(`Verified business facts (use ONLY these):\n${g.facts}`);
  if (g.people)         parts.push(`Real team members (reference ONLY these people, no invented staff):\n${g.people}`);
  if (g.alwaysInclude)  parts.push(`Always include in content:\n${g.alwaysInclude}`);
  if (g.neverSay)       parts.push(`Never say or invent:\n${g.neverSay}`);
  return "\n\n" + parts.join("\n\n");
}

export const ACTIONS = [
  { id:"blog",       label:"Blog Post",            cat:"Content",     col:"#a78bfa" },
  { id:"gbp",        label:"Google Business Post", cat:"Local SEO",   col:"#4285f4" },
  { id:"instagram",  label:"Instagram",            cat:"Social",      col:"#e1306c" },
  { id:"facebook",   label:"Facebook",             cat:"Social",      col:"#1877f2" },
  { id:"tiktok",     label:"TikTok",               cat:"Social",      col:"#ee1d52" },
  { id:"twitter",    label:"X / Twitter",          cat:"Social",      col:"#71767b" },
  { id:"linkedin",   label:"LinkedIn",             cat:"Social",      col:"#0a66c2" },
  { id:"email",      label:"Email Campaign",       cat:"Marketing",   col:"#8b5cf6" },
  { id:"sms",        label:"SMS Blast",            cat:"Marketing",   col:"#7c3aed" },
  { id:"google_ads", label:"Google Ads",           cat:"Advertising", col:"#4285f4" },
  { id:"meta_ads",   label:"Meta Ads",             cat:"Advertising", col:"#1877f2" },
];

export function getCampaignPrompt(id, c) {
  const ctx = `Restaurant: ${c.restaurant||"our restaurant"} | Goal: ${c.goal} | Topic: ${c.topic} | Tone: ${c.tone}`;
  return ({
    blog:       `Write a complete SEO blog post. ${ctx}. 450-600 words. Include title, engaging intro, 2-3 subheaded sections, conclusion with CTA.`,
    gbp:        `Write a Google Business Profile post (max 1400 chars, no hashtags). ${ctx}. Strong hook, value statement, CTA at end.`,
    instagram:  `Write an Instagram caption. ${ctx}. Punchy hook, storytelling body, strong CTA, 8-10 hashtags at end. Use emojis naturally.`,
    facebook:   `Write a Facebook post (150-250 words). ${ctx}. Conversational, shareable, end with a question to drive comments.`,
    tiktok:     `Write a TikTok script. ${ctx}. Hook in first 3 words, 3-4 punchy scenes (10-15s each), on-screen text in [brackets], closing CTA.`,
    twitter:    `Write 3 X/Twitter variations. ${ctx}. Each max 280 chars. Label "Option 1/2/3:". Witty, direct, curiosity — one each.`,
    linkedin:   `Write a LinkedIn post (200-300 words). ${ctx}. Professional yet personal, insight-driven, end with a question for comments.`,
    email:      `Write a full marketing email. ${ctx}. Label clearly: SUBJECT LINE, PREVIEW TEXT, EMAIL BODY (use {{first_name}} token, warm 3-para body, CTA label).`,
    sms:        `Write an SMS message. ${ctx}. MAX 130 chars. Punchy, personal, no links, clear CTA. ("Reply STOP to opt out" auto-appended.)`,
    google_ads: `Create Google Ads copy. ${ctx}. Provide: 5 headlines (<=30 chars each), 3 descriptions (<=90 chars each), 3 sitelinks with descriptions.`,
    meta_ads:   `Create Meta Ads copy. ${ctx}. 3 ad variations, each with: Primary text (<=125 chars), Headline (<=40 chars), Description (<=30 chars), CTA suggestion.`,
  })[id] || `Generate marketing content for ${id}. ${ctx}.`;
}

// Shared CSV parser used by CRM and Lead Agent import wizards.
// Returns { headers: string[], rows: string[][] }.
// Handles quoted values, \r\n line endings, BOM, blank rows.
export function parseCSV(text) {
  const cleaned = (text || "").replace(/^﻿/, "");
  const lines = cleaned.split(/\r?\n/).filter(l => l.trim());
  if (lines.length < 2) return { headers: [], rows: [] };
  const parseRow = line => {
    const result = []; let cur = ""; let inQ = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (ch === '"') { inQ = !inQ; }
      else if (ch === ',' && !inQ) { result.push(cur.trim().replace(/^["']|["']$/g, "")); cur = ""; }
      else { cur += ch; }
    }
    result.push(cur.trim().replace(/^["']|["']$/g, ""));
    return result;
  };
  const headers = parseRow(lines[0]);
  const rows = lines.slice(1).map(parseRow).filter(r => r.some(v => v.trim()));
  return { headers, rows };
}

// ── Brand Kit constants (foundation for AI Creative + Publishing Agent) ───────
export const BRAND_VOICE_TONES = [
  { id: "warm",          label: "Warm" },
  { id: "professional",  label: "Professional" },
  { id: "playful",       label: "Playful" },
  { id: "bold",          label: "Bold" },
  { id: "authoritative", label: "Authoritative" },
  { id: "casual",        label: "Casual" },
];
export const BRAND_VISUAL_STYLES = [
  { id: "modern_minimal", label: "Modern minimal" },
  { id: "warm_friendly",  label: "Warm & friendly" },
  { id: "bold",           label: "Bold" },
  { id: "premium",        label: "Premium" },
  { id: "clean_clinical", label: "Clean clinical" },
];
export const BRAND_FONT_OPTIONS = [
  "Inter", "Roboto", "Open Sans", "Lato", "Montserrat", "Poppins", "Raleway",
  "Source Sans Pro", "Nunito", "Work Sans", "Manrope", "DM Sans", "Plus Jakarta Sans",
  "Playfair Display", "Merriweather", "Lora", "Cormorant Garamond", "EB Garamond",
  "Oswald", "Bebas Neue", "Rubik", "Karla", "IBM Plex Sans", "Space Grotesk", "Outfit",
];
export const BRAND_CTA_SUGGESTIONS = {
  restaurant:   ["Reserve a table",    "View Menu",            "Order Online"],
  healthcare:   ["Book Appointment",   "Schedule Consultation", "Call Today"],
  home_service: ["Get a Free Quote",   "Schedule Service",      "Call Now"],
  retail:       ["Shop Now",           "Browse Products",       "Visit Store"],
  default:      ["Book Now",           "Get a Quote",           "Learn More"],
};

// ── Topic distribution — Content Agent category mix (shared by content-engine module + Plan Dashboard editors) ──
export const SEED_TOPIC_CATEGORIES = [
  { id: "local",       label: "Local Intent",  weight: 50, hint: "Best X in [city], X near me" },
  { id: "educational", label: "Educational",   weight: 30, hint: "How to choose X, what is Y" },
  { id: "comparison",  label: "Comparison",    weight: 10, hint: "X vs Y, best X under $50" },
  { id: "seasonal",    label: "Seasonal",      weight: 10, hint: "Holiday X, summer Y" },
];

export function slugifyTopicCategoryId(label, existing) {
  const base = String(label || "").toLowerCase().trim()
    .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "category";
  let id = base;
  let n = 2;
  while (existing.has(id)) { id = `${base}-${n}`; n++; }
  return id;
}

export function normaliseTopicWeights(cats) {
  const sum = cats.reduce((a, c) => a + (c.weight || 0), 0);
  if (sum === 100 || sum === 0) return cats;
  let scaled = cats.map(c => ({ ...c, weight: Math.round((c.weight / sum) * 100) }));
  const drift = 100 - scaled.reduce((a, c) => a + c.weight, 0);
  if (drift !== 0 && scaled.length > 0) {
    scaled = scaled.map((c, i) => i === 0 ? { ...c, weight: c.weight + drift } : c);
  }
  return scaled;
}

export function validateTopicCategories(cats) {
  if (!Array.isArray(cats) || cats.length === 0) return "Add at least one category.";
  const ids = new Set();
  for (const c of cats) {
    if (!c.id) return "Each category needs an id.";
    if (ids.has(c.id)) return `Duplicate category id "${c.id}".`;
    ids.add(c.id);
    if (!c.label || !c.label.trim()) return "Every category needs a label.";
    if (!c.hint  || !c.hint.trim())  return `"${c.label}" needs a hint (short example for the AI).`;
    if (typeof c.weight !== "number" || c.weight < 0) return `"${c.label}" has an invalid weight.`;
  }
  const sum = cats.reduce((a, c) => a + c.weight, 0);
  if (sum !== 100) return `Weights must add to 100 (currently ${sum}). Click Normalise to fix.`;
  return null;
}


// ── NICHES — supported business niches (shared: buildAppContext + many App.jsx components) ──
export const NICHES = [
  {
    id: "restaurant",
    icon: "🍽️",
    label: "Restaurant",
    desc: "Cafes, bars, fine dining, fast casual & more",
    nameLabel: "Business Name",
    namePlaceholder: "e.g. Kurb Plumbing",
    categoryLabel: "Cuisine Type",
    categories: ["Italian","Japanese","Mexican","French","Chinese","Indian","American","Mediterranean","Thai","Greek","Spanish","Middle Eastern","Korean","Vietnamese","Seafood","Steakhouse","Pizza","Sushi","Farm-to-Table","Fusion","Brunch","Fine Dining","Casual Dining","Fast Casual","Bakery & Café","Bar & Grill"],
    vibeLabel: "Restaurant Vibe",
    vibes: ["Romantic & Intimate","Family-Friendly","Trendy & Modern","Classic & Traditional","Cozy & Rustic","Lively & Social","Upscale & Refined","Casual & Relaxed"],
    descPlaceholder: (n,c) => `e.g. ${n||"Our restaurant"} serves ${c||"delicious food"} in a welcoming atmosphere…`,
    goals: [
      { id:"reservations", icon:"📅", label:"Fill more tables",          desc:"Drive bookings every week" },
      { id:"awareness",    icon:"📣", label:"Get discovered locally",    desc:"New customers from Google & social" },
      { id:"retention",    icon:"💌", label:"Keep regulars coming back", desc:"Email, SMS & loyalty campaigns" },
      { id:"all",          icon:"⚡", label:"All of the above",           desc:"Full autopilot marketing" },
    ],
    testimonial: '"The easiest marketing tool I\'ve ever used. Set it up once, it runs itself."',
    testimonialBy: "— Restaurant owner, Atlanta GA",
  },
  {
    id: "home_services",
    icon: "🏠",
    label: "Home Services",
    desc: "Plumbers, HVAC, landscapers, electricians & more",
    nameLabel: "Business Name",
    namePlaceholder: "e.g. Apex Plumbing & HVAC",
    categoryLabel: "Service Type",
    categories: ["Plumbing","HVAC","Landscaping","Cleaning","Electrical","Roofing","Painting","Pest Control","Pool Service","Handyman","Tree Service","Flooring","Remodeling","Windows","Solar","Garage Doors"],
    vibeLabel: null,
    vibes: [],
    descPlaceholder: (n,c) => `e.g. ${n||"Our business"} provides reliable ${c||"home service"} across the local area…`,
    goals: [
      { id:"leads",     icon:"📣", label:"Get more leads",          desc:"Rank locally & fill the schedule" },
      { id:"reviews",   icon:"⭐", label:"Build 5-star reputation", desc:"Request & respond to reviews" },
      { id:"retention", icon:"💌", label:"Win repeat customers",    desc:"Seasonal campaigns & follow-ups" },
      { id:"all",       icon:"⚡", label:"All of the above",        desc:"Full autopilot marketing" },
    ],
    testimonial: '"Went from 10 to 40 Google reviews in 3 months. Booked solid."',
    testimonialBy: "— HVAC contractor, Denver CO",
  },
  {
    id: "healthcare",
    icon: "🏥",
    label: "Healthcare Clinic",
    desc: "Dental, physio, chiro, GP, mental health & more",
    nameLabel: "Practice Name",
    namePlaceholder: "e.g. Bright Smile Dental",
    categoryLabel: "Specialty",
    categories: ["Dental","Physiotherapy","Chiropractic","GP / Family Medicine","Dermatology","Optometry","Mental Health","Nutrition","Podiatry","Specialist Clinic"],
    vibeLabel: null,
    vibes: [],
    descPlaceholder: (n,c) => `e.g. ${n||"Our clinic"} provides ${c||"healthcare"} in a caring, modern environment…`,
    goals: [
      { id:"patients",     icon:"📣", label:"Attract new patients",   desc:"Be found on Google & Maps" },
      { id:"appointments", icon:"📅", label:"Fill appointment slots", desc:"Reduce no-shows, stay booked" },
      { id:"trust",        icon:"⭐", label:"Build trust & reviews",  desc:"Reputation management on autopilot" },
      { id:"all",          icon:"⚡", label:"All of the above",       desc:"Full autopilot marketing" },
    ],
    testimonial: '"New patient bookings doubled in 60 days. Incredible ROI."',
    testimonialBy: "— Dental clinic owner, Sydney",
  },
];

// ── DEFAULT_OUTCOMES — Default-Mode outcome templates per niche (shared: AI + DefaultShell) ──
export const DEFAULT_OUTCOMES = {
  restaurant: [
    { id:"fill_tables",     icon:"🍽️", title:"Fill Tables This Weekend",    subtitle:"Get more people in seats right now", color:"#f59e0b",
      questions:[{key:"date",label:"Which weekend?",placeholder:"e.g. This Saturday & Sunday"},{key:"offer",label:"Any special offer?",placeholder:"e.g. 20% off, live music (optional)"}],
      channels:["instagram","facebook","sms","gbp","google_ads"], goal:"drive reservations", tone:"engaging",
      topicFn:(biz,a)=>`Drive weekend diners to ${biz}${a.date?" on "+a.date:""}. ${a.offer||"Great food and atmosphere"}. Create urgency to book now.` },
    { id:"get_reservations", icon:"📅", title:"Get More Reservations",        subtitle:"Keep your calendar full every week",  color:"#10b981",
      questions:[{key:"offer",label:"Any reason to book now?",placeholder:"e.g. New menu, limited seats, special event (optional)"}],
      channels:["email","sms","instagram","facebook","google_ads"], goal:"drive reservations", tone:"engaging",
      topicFn:(biz,a)=>`Drive reservations at ${biz}. ${a.offer||"Book a table for an unforgettable dining experience"}. Make it easy and urgent.` },
    { id:"promote_special",  icon:"✨", title:"Promote a Special or New Menu", subtitle:"Turn your new offering into a buzz moment", color:"#8b5cf6",
      questions:[{key:"what",label:"What are you promoting?",placeholder:"e.g. New spring menu, weekend brunch, chef's special"},{key:"date",label:"When does it start?",placeholder:"e.g. This Friday (optional)"}],
      channels:["blog","instagram","facebook","tiktok","email","gbp"], goal:"brand awareness", tone:"storytelling",
      topicFn:(biz,a)=>`${a.what||"New special"} at ${biz}${a.date?" starting "+a.date:""}. Create excitement and drive visits.` },
    { id:"reactivate_guests", icon:"💌", title:"Reactivate Past Guests",       subtitle:"Bring back customers who haven't visited lately", color:"#ec4899",
      questions:[{key:"offer",label:"Any comeback offer?",placeholder:"e.g. 15% off next visit, free dessert (optional)"}],
      channels:["email","sms"], goal:"re-engage guests", tone:"warm",
      topicFn:(biz,a)=>`Win back past guests at ${biz}. ${a.offer||"We miss you — come back for something special"}. Warm, personal, not pushy.` },
    { id:"boost_reviews",    icon:"⭐", title:"Boost Your Google Reviews",     subtitle:"More reviews = more new customers", color:"#facc15",
      questions:[{key:"link",label:"Your Google review link",placeholder:"https://g.page/r/... (optional)"}],
      channels:["email","sms"], goal:"brand awareness", tone:"warm",
      topicFn:(biz,a)=>`Review request for ${biz}. Ask recent guests to share their experience on Google${a.link?" at "+a.link:""}. Genuine, not pushy.` },
    { id:"grand_opening",    icon:"🎉", title:"Grand Opening / Relaunch",      subtitle:"Maximum buzz for your big moment", color:"#f97316",
      questions:[{key:"date",label:"Opening date",placeholder:"e.g. Saturday, May 10th"},{key:"offer",label:"Opening special?",placeholder:"e.g. Free welcome drink (optional)"}],
      channels:["blog","instagram","facebook","tiktok","email","sms","google_ads","meta_ads","gbp"], goal:"brand awareness", tone:"engaging",
      topicFn:(biz,a)=>`Grand Opening of ${biz}${a.date?" on "+a.date:""}. ${a.offer||"Celebrate with us"}. Maximum buzz, excitement, and foot traffic.` },
  ],
  home_services: [
    { id:"get_calls",          icon:"📞", title:"Get More Calls Today",        subtitle:"Fill your schedule with qualified leads", color:"#3b82f6",
      questions:[{key:"service",label:"What service?",placeholder:"e.g. Emergency plumbing, AC repair, lawn care"},{key:"area",label:"Service area",placeholder:"e.g. Atlanta Metro (optional)"}],
      channels:["google_ads","gbp","instagram","facebook"], goal:"generate leads", tone:"direct",
      topicFn:(biz,a)=>`Get calls for ${a.service||"home services"} at ${biz}${a.area?" serving "+a.area:""}. Fast response, reliable, call now.` },
    { id:"book_jobs",          icon:"🔧", title:"Book More Jobs This Week",     subtitle:"Keep your crew busy all week long", color:"#10b981",
      questions:[{key:"service",label:"Which service?",placeholder:"e.g. Landscaping, HVAC tune-up, painting"},{key:"offer",label:"Any promotion?",placeholder:"e.g. 10% off, free estimate (optional)"}],
      channels:["google_ads","facebook","email","sms"], goal:"drive reservations", tone:"engaging",
      topicFn:(biz,a)=>`Book ${a.service||"home service jobs"} at ${biz}. ${a.offer||"Fast, reliable service"}. Drive bookings this week.` },
    { id:"emergency_leads",    icon:"🚨", title:"Emergency Leads Now",          subtitle:"Capture urgent, high-intent customers", color:"#ef4444",
      questions:[{key:"service",label:"What emergency service?",placeholder:"e.g. Emergency plumbing, 24/7 HVAC, storm cleanup"}],
      channels:["google_ads","gbp"], goal:"generate leads", tone:"direct",
      topicFn:(biz,a)=>`${a.service||"Emergency service"} by ${biz}. Available now, fast response, licensed and insured. Call immediately.` },
    { id:"seasonal_promo",     icon:"🌿", title:"Seasonal Promotion",           subtitle:"Capitalize on seasonal demand", color:"#f59e0b",
      questions:[{key:"season",label:"What season or occasion?",placeholder:"e.g. Spring lawn prep, Summer AC check, Fall gutters"},{key:"offer",label:"Special offer?",placeholder:"e.g. 20% off, free inspection (optional)"}],
      channels:["email","sms","facebook","instagram","gbp"], goal:"promote offer", tone:"engaging",
      topicFn:(biz,a)=>`${a.season||"Seasonal special"} at ${biz}. ${a.offer||"Limited-time offer"}. Book before slots fill up.` },
    { id:"reactivate_customers",icon:"💌", title:"Win Back Past Customers",     subtitle:"Your best leads have hired you before", color:"#8b5cf6",
      questions:[{key:"offer",label:"Loyalty offer?",placeholder:"e.g. 15% off for returning customers (optional)"}],
      channels:["email","sms"], goal:"re-engage guests", tone:"warm",
      topicFn:(biz,a)=>`Re-engage past customers of ${biz}. ${a.offer||"We appreciate your loyalty — here's a reason to call us again"}.` },
    { id:"boost_reviews_hs",   icon:"⭐", title:"Boost Your Google Reviews",    subtitle:"More 5-star reviews = more inbound calls", color:"#facc15",
      questions:[{key:"link",label:"Your Google review link",placeholder:"https://g.page/r/... (optional)"}],
      channels:["email","sms"], goal:"brand awareness", tone:"warm",
      topicFn:(biz,a)=>`Review request for ${biz}. Ask recent customers to leave a Google review${a.link?" at "+a.link:""}. Genuine, not pushy.` },
  ],
  healthcare: [
    { id:"get_appointments",   icon:"📅", title:"Get More Appointments",        subtitle:"Fill your calendar with new patients", color:"#3b82f6",
      questions:[{key:"service",label:"Which service or treatment?",placeholder:"e.g. New patient consult, teeth cleaning, physio"}],
      channels:["google_ads","facebook","email","gbp"], goal:"drive reservations", tone:"professional",
      topicFn:(biz,a)=>`Book ${a.service||"appointments"} at ${biz}. Accepting new patients, caring team, easy booking.` },
    { id:"fill_slots",         icon:"🗓️", title:"Fill Cancelled Slots",          subtitle:"Turn cancellations into booked revenue", color:"#10b981",
      questions:[{key:"slots",label:"Availability",placeholder:"e.g. This week, Tuesday afternoon (optional)"}],
      channels:["sms","email"], goal:"drive reservations", tone:"professional",
      topicFn:(biz,a)=>`Last-minute appointment availability at ${biz}${a.slots?" — "+a.slots:""}. Book now while slots are open.` },
    { id:"promote_service_hc", icon:"✨", title:"Promote a New Service",         subtitle:"Introduce a new offering to your patients", color:"#8b5cf6",
      questions:[{key:"service",label:"What new service?",placeholder:"e.g. Teeth whitening, online consults, sports physio"}],
      channels:["email","facebook","instagram","gbp"], goal:"brand awareness", tone:"professional",
      topicFn:(biz,a)=>`${a.service||"New service"} now available at ${biz}. Learn more and book an appointment today.` },
    { id:"reactivate_patients", icon:"💌", title:"Reactivate Past Patients",     subtitle:"Past patients convert at 3× the rate", color:"#ec4899",
      questions:[{key:"offer",label:"Any reason to return?",placeholder:"e.g. Annual check-up reminder, new treatment (optional)"}],
      channels:["email","sms"], goal:"re-engage guests", tone:"warm",
      topicFn:(biz,a)=>`Re-engage past patients of ${biz}. ${a.offer||"It's been a while — your health matters, book your check-up today"}.` },
    { id:"boost_reviews_hc",   icon:"⭐", title:"Boost Your Google Reviews",     subtitle:"Patients trust clinics with more 5-star reviews", color:"#facc15",
      questions:[{key:"link",label:"Your Google review link",placeholder:"https://g.page/r/... (optional)"}],
      channels:["email","sms"], goal:"brand awareness", tone:"professional",
      topicFn:(biz,a)=>`Review request for ${biz}. Ask recent patients to share their experience on Google${a.link?" at "+a.link:""}. Warm, professional tone.` },
  ],
};

// ── DEFAULT_NAV — Default-Mode nav (shared: buildAppContext + DefaultShell) ──
export const DEFAULT_NAV = [
  { id:"dashboard", icon:"▦", label:"Dashboard" },
  { id:"campaigns", icon:"⚡", label:"Campaigns" },
  { id:"customers", icon:"◈", label:"Customers" },
  { id:"settings",  icon:"⚙", label:"Settings" },
];

// ── TEMPLATE_GROUPS + ALL_TEMPLATES — campaign templates (shared: campaigns.jsx + AI) ──
export const TEMPLATE_GROUPS = [
  {
    id: "most_used",
    label: "🔥 Most Used",
    desc: "Start here — highest impact for any restaurant",
    templates: [
      {
        id: "fill_slow_days",
        recommended: true,
        icon: "🕒",
        name: "Fill Slow Days",
        promise: "Turn your slowest days into profitable ones",
        when: "Mondays, Tuesdays, or any day that's consistently quiet",
        outcome: "Typically 20–40 extra covers on slow days",
        time: "60 sec to launch",
        color: "#f59e0b",
        goal: "drive reservations",
        tone: "urgent",
        schedule: {type:"weekly",time:"07:30",day:1,date:1},
        channels: ["instagram","facebook","sms","meta_ads"],
        channelLabel: "Social + Ads + SMS",
        fields: [
          {key:"slowDay", label:"Your slowest day(s)", placeholder:"e.g. Monday & Tuesday"},
          {key:"offer",   label:"Incentive to come in", placeholder:"e.g. 20% off, free starter, complimentary wine"},
        ],
        topicFn: (r,f) => `${r} is running a promotion to fill seats on ${f.slowDay||"slow weekdays"}. Offer: ${f.offer||"special deal for dining in"}. Goal: drive immediate reservations and walk-ins with strong urgency and a clear reason to come in today rather than the weekend.`,
      },
      {
        id: "get_new_customers",
        recommended: true,
        icon: "📈",
        name: "Get New Customers",
        promise: "Attract first-time visitors to your restaurant",
        when: "Any time — this should always be running",
        outcome: "Expand your customer base in your local area",
        time: "60 sec to launch",
        color: "#6366f1",
        goal: "brand awareness",
        tone: "engaging",
        schedule: {type:"weekly",time:"09:00",day:2,date:1},
        channels: ["instagram","facebook","google_ads","meta_ads","gbp"],
        channelLabel: "Social + Google + Meta Ads",
        fields: [
          {key:"cuisine",    label:"Your cuisine / vibe", placeholder:"e.g. authentic Italian, modern Asian, farm-to-table"},
          {key:"bestDish",   label:"Your most popular dish", placeholder:"e.g. Wagyu Tagliatelle, Crispy Duck"},
        ],
        topicFn: (r,f) => `Attract new customers to ${r}, a ${f.cuisine||"upscale"} restaurant. Hero dish to feature: ${f.bestDish||"our signature dish"}. Target local food lovers who haven't discovered us yet. Make it compelling, specific, and mouth-watering.`,
      },
      {
        id: "fill_weekend",
        icon: "🚀",
        name: "Fill This Weekend",
        promise: "Get more customers Friday through Sunday",
        when: "Every Wednesday or Thursday — recurring weekly",
        outcome: "Fuller weekend tables, more revenue per week",
        time: "60 sec to launch",
        color: "#10b981",
        goal: "drive reservations",
        tone: "urgent",
        schedule: {type:"weekly",time:"08:00",day:3,date:1},
        channels: ["instagram","facebook","sms","meta_ads"],
        channelLabel: "Social + Ads + SMS",
        fields: [
          {key:"special", label:"Weekend hook or special", placeholder:"e.g. Live jazz Friday, Chef's tasting menu Sat, Sunday brunch"},
        ],
        topicFn: (r,f) => `Weekend promotion for ${r}. This weekend: ${f.special||"special dining experience"}. Create urgency to book Friday, Saturday, or Sunday — spots are limited. Make it feel exclusive and time-sensitive.`,
      },
    ]
  },
  {
    id: "promotions",
    label: "🎯 Promotions",
    desc: "Drive bookings with time-sensitive offers",
    templates: [
      {
        id: "flash_sale",
        icon: "⚡",
        name: "48-Hour Flash Sale",
        promise: "Drive immediate traffic in the next 2 days",
        when: "When you need to fill seats fast — unexpected quiet period",
        outcome: "Immediate spike in bookings within 24–48 hours",
        time: "60 sec to launch",
        color: "#f97316",
        goal: "drive reservations",
        tone: "urgent",
        schedule: {type:"once",time:"10:00",day:1,date:1},
        channels: ["instagram","facebook","sms","meta_ads"],
        channelLabel: "Social + Ads + SMS",
        fields: [
          {key:"deal",   label:"The offer", placeholder:"e.g. 25% off all mains, Free dessert for 2, Complimentary wine"},
          {key:"expiry", label:"Deadline", placeholder:"e.g. Next 48 hours, This weekend only, Tonight only"},
        ],
        topicFn: (r,f) => `URGENT flash promotion at ${r}: ${f.deal||"exclusive limited-time offer"}. Expires ${f.expiry||"in 48 hours"}. This is a time-critical campaign — write with maximum urgency, FOMO, and a crystal-clear call to book now.`,
      },
      {
        id: "holiday_rush",
        icon: "🎄",
        name: "Holiday Rush",
        promise: "Turn holidays into your highest-revenue days",
        when: "1–2 weeks before any major holiday or seasonal event",
        outcome: "Fully booked holiday sittings, gift card sales",
        time: "90 sec to launch",
        color: "#ef4444",
        goal: "seasonal offer",
        tone: "warm",
        schedule: {type:"once",time:"09:00",day:1,date:1},
        channels: ["instagram","facebook","email","sms","meta_ads"],
        channelLabel: "Social + Email + SMS + Ads",
        fields: [
          {key:"holiday", label:"Holiday / occasion", placeholder:"e.g. Christmas Eve, Thanksgiving, Mother's Day"},
          {key:"offer",   label:"Special menu or offer", placeholder:"e.g. 4-course set menu at $85, 20% off Dec 22–26"},
          {key:"dates",   label:"Promotion dates", placeholder:"e.g. Dec 22–26"},
        ],
        topicFn: (r,f) => `${f.holiday||"Holiday"} promotion at ${r}. Special: ${f.offer||"festive menu"}. Running ${f.dates||"this holiday season"}. Drive reservations and gift card purchases. Add seasonal warmth and urgency around limited availability.`,
      },
      {
        id: "lunch_special",
        icon: "🍔",
        name: "Lunch Special",
        promise: "Drive traffic during lunch hours",
        when: "To fill seats between 11am–2pm on weekdays",
        outcome: "Build a consistent lunch crowd and daytime revenue",
        time: "60 sec to launch",
        color: "#eab308",
        goal: "drive reservations",
        tone: "engaging",
        schedule: {type:"weekly",time:"08:00",day:1,date:1},
        channels: ["instagram","facebook","google_ads","gbp"],
        channelLabel: "Social + Google + Google Business",
        fields: [
          {key:"menu",  label:"Lunch menu or deal", placeholder:"e.g. 2-course lunch for $25, Express set menu, Half-price burgers"},
          {key:"time",  label:"Lunch hours", placeholder:"e.g. Mon–Fri 11:30am–2:30pm"},
        ],
        topicFn: (r,f) => `Lunch promotion at ${r}. Offer: ${f.menu||"special lunch deal"}. Available ${f.time||"weekday lunchtimes"}. Target office workers, local professionals, and shoppers looking for a great value lunch nearby.`,
      },
      {
        id: "happy_hour",
        icon: "🍹",
        name: "Happy Hour Boost",
        promise: "Fill seats during off-peak hours",
        when: "Afternoons and early evenings that are consistently quiet",
        outcome: "Extra revenue in dead hours, new habitual customers",
        time: "60 sec to launch",
        color: "#a855f7",
        goal: "drive reservations",
        tone: "engaging",
        schedule: {type:"weekly",time:"13:00",day:3,date:1},
        channels: ["instagram","facebook","sms"],
        channelLabel: "Social + SMS",
        fields: [
          {key:"deal",  label:"Happy hour deal", placeholder:"e.g. Half-price cocktails, $6 beers, 2-for-1 wine 4–6pm"},
          {key:"hours", label:"Happy hour times", placeholder:"e.g. Mon–Fri 3pm–6pm"},
        ],
        topicFn: (r,f) => `Happy hour at ${r}: ${f.deal||"special drinks and bites offer"} from ${f.hours||"3pm–6pm"}. Fun, vibrant, and social — great after-work spot. Drive walk-in traffic and build the after-work crowd.`,
      },
    ]
  },
  {
    id: "retention",
    label: "🔁 Retention",
    desc: "Keep your best customers coming back",
    templates: [
      {
        id: "bring_back",
        icon: "💌",
        name: "Bring Customers Back",
        promise: "Re-engage guests who haven't visited recently",
        when: "Monthly — target guests who haven't been in 60+ days",
        outcome: "5–15% of lapsed customers return within 2 weeks",
        time: "60 sec to launch",
        color: "#8b5cf6",
        goal: "build loyalty",
        tone: "warm",
        schedule: {type:"monthly",time:"10:00",day:1,date:1},
        channels: ["email","sms"],
        channelLabel: "Email + SMS",
        fields: [
          {key:"incentive", label:"Reason to come back", placeholder:"e.g. 15% off your next visit, Free glass of wine on us"},
          {key:"news",      label:"What's new at the restaurant", placeholder:"e.g. New spring menu, fresh interior, new chef"},
        ],
        topicFn: (r,f) => `Guest win-back campaign for ${r}. We miss you. ${f.news||"A lot has changed since your last visit"}. Come back and enjoy ${f.incentive||"a special welcome-back offer"}. Warm, personal, no hard sell — make them feel remembered and valued.`,
      },
      {
        id: "weekly_specials",
        icon: "📣",
        name: "Weekly Specials Engine",
        promise: "Stay top of mind and keep customers coming back",
        when: "Every week — set it once, runs on autopilot forever",
        outcome: "Consistent social presence + repeat customer habit",
        time: "60 sec to set up",
        color: "#06b6d4",
        goal: "build loyalty",
        tone: "engaging",
        schedule: {type:"weekly",time:"08:00",day:2,date:1},
        channels: ["instagram","facebook","gbp"],
        channelLabel: "Social + Google Business",
        fields: [
          {key:"format", label:"What makes each week special", placeholder:"e.g. New seasonal dish, weekly chef's special, guest ingredient"},
        ],
        topicFn: (r,f) => `Weekly content campaign for ${r}. Format: ${f.format||"weekly chef's special or seasonal feature"}. Keep the restaurant in followers' feeds consistently — fresh, engaging, and always giving people a reason to come in this week.`,
      },
    ]
  },
  {
    id: "growth",
    label: "📣 Growth",
    desc: "Build brand, reputation, and long-term demand",
    templates: [
      {
        id: "grand_opening",
        recommended: true,
        icon: "🎉",
        name: "Grand Opening",
        promise: "Make your first impression count and drive traffic fast",
        when: "New restaurant, major rebrand, or reopening",
        outcome: "Maximum buzz, awareness, and opening day foot traffic",
        time: "2 min to launch",
        color: "#f59e0b",
        goal: "brand awareness",
        tone: "engaging",
        schedule: {type:"once",time:"09:00",day:1,date:1},
        channels: ["blog","instagram","facebook","tiktok","email","sms","google_ads","meta_ads","gbp"],
        channelLabel: "All Channels",
        fields: [
          {key:"openingDate", label:"Opening date", placeholder:"e.g. Saturday, May 10th"},
          {key:"offer",       label:"Opening special (optional)", placeholder:"e.g. Free dessert for first 100 guests, complimentary welcome drink"},
        ],
        topicFn: (r,f) => `Grand Opening of ${r}${f.openingDate?" on "+f.openingDate:""}. ${f.offer||"Special opening celebration for the community"}. Drive maximum buzz, excitement, and foot traffic. This is our moment — make it unforgettable.`,
      },
      {
        id: "new_menu",
        icon: "🍽️",
        name: "New Menu Launch",
        promise: "Turn your new menu into a must-try event",
        when: "Seasonal menu change, new chef, expanded offerings",
        outcome: "Strong opening week traffic + social media buzz",
        time: "90 sec to launch",
        color: "#10b981",
        goal: "launch menu",
        tone: "storytelling",
        schedule: {type:"once",time:"09:00",day:1,date:1},
        channels: ["blog","gbp","instagram","facebook","tiktok","email","google_ads"],
        channelLabel: "Content + Social + Search + Email",
        fields: [
          {key:"menuName",   label:"Menu name or season", placeholder:"e.g. Spring 2026, Summer Tasting Menu"},
          {key:"highlights", label:"2–3 hero dishes", placeholder:"e.g. Truffle Tagliatelle, Wagyu Short Rib, Yuzu Tart"},
          {key:"launchDate", label:"Launch date", placeholder:"e.g. April 28th"},
        ],
        topicFn: (r,f) => `New ${f.menuName||"seasonal menu"} launch at ${r}${f.launchDate?" on "+f.launchDate:""}. Hero dishes: ${f.highlights||"exciting new creations"}. Tell the story of the chef's inspiration, the seasonal ingredients, and why this is a must-try. Invite guests to be the first to experience it.`,
      },
      {
        id: "review_booster",
        recommended: true,
        icon: "⭐",
        name: "5-Star Review Booster",
        promise: "Get more Google reviews and improve your ranking",
        when: "Any time — more reviews = more organic customers",
        outcome: "More Google reviews, better local SEO, more walk-ins",
        time: "60 sec to launch",
        color: "#facc15",
        goal: "brand awareness",
        tone: "warm",
        schedule: {type:"monthly",time:"10:00",day:1,date:7},
        channels: ["email","sms"],
        channelLabel: "Email + SMS",
        fields: [
          {key:"reviewLink", label:"Your Google review link", placeholder:"https://g.page/r/your-restaurant/review"},
        ],
        topicFn: (r,f) => `Review request campaign for ${r}. Ask recent guests to leave a Google review at ${f.reviewLink||"[REVIEW_LINK]"}. Warm, genuine, personal — not pushy. Remind them how much their experience mattered and how a review helps a small business. No incentives (Google policy).`,
      },
      {
        id: "valentines",
        icon: "🥂",
        name: "Valentine's Day",
        promise: "Fully book your busiest night of the year",
        when: "Start promoting 2–3 weeks before February 14th",
        outcome: "Fully booked Valentine's dinner, premium revenue night",
        time: "90 sec to launch",
        color: "#ec4899",
        goal: "promote event",
        tone: "luxurious",
        schedule: {type:"once",time:"09:00",day:1,date:1},
        channels: ["instagram","facebook","email","sms","meta_ads","gbp"],
        channelLabel: "Social + Email + SMS + Ads",
        fields: [
          {key:"menu",   label:"Valentine's menu or offer", placeholder:"e.g. 5-course set menu for 2, $120 per couple"},
          {key:"extras", label:"Special touches", placeholder:"e.g. Rose on arrival, live piano, champagne toast"},
        ],
        topicFn: (r,f) => `Valentine's Day dinner at ${r}. ${f.menu||"Special couples set menu"}. ${f.extras||"Romantic atmosphere, intimate setting"}. Limited seats — create urgency to book now. Make it feel like the most romantic night of the year.`,
      },
      {
        id: "local_buzz",
        icon: "🎭",
        name: "Ride Local Buzz",
        promise: "Attract traffic from nearby events and crowds",
        when: "Before any local event, festival, game, or market",
        outcome: "Capture spillover traffic from event attendees",
        time: "60 sec to launch",
        color: "#06b6d4",
        goal: "brand awareness",
        tone: "engaging",
        schedule: {type:"once",time:"08:00",day:1,date:1},
        channels: ["instagram","facebook","gbp","google_ads"],
        channelLabel: "Social + Google Ads",
        fields: [
          {key:"event", label:"Local event or occasion", placeholder:"e.g. Jazz Festival, City Marathon, Farmers Market"},
          {key:"angle", label:"Your angle or offer", placeholder:"e.g. Perfect pre-show dinner, post-race brunch spot, festival after-party"},
        ],
        topicFn: (r,f) => `${r} is the perfect restaurant for ${f.event||"the upcoming local event"}. ${f.angle||"Come dine with us before, during, or after"}. Position us as the natural choice for event-goers — convenient, welcoming, and a great way to make the day complete.`,
      },
    ]
  },
];

export const ALL_TEMPLATES = TEMPLATE_GROUPS.flatMap(g => g.templates);

// ── logActivity — append to activity_log store (shared: App.jsx + AI executeAction) ──
export async function logActivity(type, action, details = {}) {
  const log = await store.get("activity_log") || [];
  log.unshift({
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    type, action, details,
    timestamp: new Date().toISOString(),
    status: details.status || "success",
  });
  await store.set("activity_log", log.slice(0, 1000));
}


// ── CATEGORY_BADGE — Lead Agent reply-category badges (shared: lead-agent module + Inbox lead_reply card) ──
export const CATEGORY_BADGE = {
  positive:            { label: "Positive",       emoji: "🎉", bg: "#dcfce7", fg: "#166534" },
  request_pricing:     { label: "Pricing",        emoji: "💰", bg: "#fef3c7", fg: "#92400e" },
  request_info:        { label: "Info",           emoji: "📚", bg: "#e0e7ff", fg: "#3730a3" },
  appointment_request: { label: "Appointment",    emoji: "📅", bg: "#ede9fe", fg: "#5b21b6" },
  not_interested:      { label: "Not interested", emoji: "🚫", bg: "#fee2e2", fg: "#b91c1c" },
  ooo:                 { label: "Out of office",  emoji: "🌴", bg: "#dbeafe", fg: "#1e40af" },
  spam:                { label: "Spam",           emoji: "🛑", bg: "#f3f4f6", fg: "#6b7280" },
  other:               { label: "Other",          emoji: "💬", bg: "#e5e7eb", fg: "#374151" },
};

// ── IA_STATUS_LABEL — Index Agent status humanization (shared: seo module + inbox card) ──
export const IA_STATUS_LABEL = {
  indexed: "Indexed", submitted: "Submitted",
  not_indexed: "Not Indexed", discovered_not_crawled: "Discovered, not crawled",
  crawled_not_indexed: "Crawled, not indexed",
  duplicate_no_canonical: "Duplicate (no canonical)",
  alternate_with_canonical: "Alternate (canonical)",
  blocked_robots: "Blocked by robots.txt", blocked_noindex: "Blocked by noindex",
  redirected: "Redirected", "404_not_found": "404 Not Found", soft_404: "Soft 404",
  server_error: "Server Error", unknown: "Unknown",
  not_discovered: "Not yet discovered",
};

// ── SP9_DRAFTABLE_FE — Lead Agent reply categories that get an AI draft (shared: lead-agent module + inbox lead_reply card) ──
export const SP9_DRAFTABLE_FE = new Set(["positive", "request_pricing", "request_info", "appointment_request", "other"]);
